import React, { useState } from "react";
import { Box, Typography, Button, Avatar } from "@mui/material";

// example imports — replace with your actual files:
// import bg1 from "../images/Dashboard.png";
import bg2 from "../images/product.png";
import bg3 from "../images/product2.png";
import bg4 from "../images/AIChatBot.jpg";
import bg5 from "../images/AiVideo.jpg";
import bg6 from "../images/Digi.jpg";
import bg7 from "../images/SEO.jpg";
import bg8 from "../images/mobileApp.jpg";

// import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import SearchRounded from "@mui/icons-material/SearchRounded";
import FolderSpecialRounded from "@mui/icons-material/FolderSpecialRounded";
import SmartToyRounded from "@mui/icons-material/SmartToyRounded";
import SmartDisplayRounded from "@mui/icons-material/SmartDisplayRounded";
import TrendingUpRounded from "@mui/icons-material/TrendingUpRounded";

const cards = [
  // {
  //   img: bg1,
  //   logo: DashboardCustomizeIcon,
  //   label: "Dashboard",

  // },
  // {
  //   img: bg2,
  //   logo: SearchRounded,
  //   label: "Asset Explorer",
  //   title: "EAM Web & Mobile App",
  //   subtitle:
  //     "A Enterprise Asset Management (EAM) solution designed to optimize the management of your organization’s assets throughout their entire lifecycle, from asset acquisition to disposal. Oriens EAM empowers you to maximize asset performance, minimize downtime, and drive operational efﬁency across your enterprise. Say goodbye to fragmanted asset management processes and embrace a uniﬁed approach with our cutting-edge EAM Solution.",
  //   stats: [
  //     { value: "99.8%", label: "System uptime", color: "#4CAF50" },
  //     { value: "40%", label: "Downtime reduction", color: "#FF9800" },
  //     { value: "3x", label: "Faster asset insights", color: "#03A9F4" },
  //   ],
  // },
  {
    img: bg3,
    logo: FolderSpecialRounded,
    label: "EAM",
    title: "EAM Web & Mobile App",
    subtitle: `Transform your asset management practices, drive operational excellence and unlock new levels of efficiency and productivity.

Why Use EAM?
• Regular maintenance and monitoring reduce wear and tear.
• Proactive maintenance minimizes unexpected failures.
• Efficient resource management cuts maintenance and operational expenses.

Benefits
• Improved asset performance.
• Reduced downtime.
• Cost savings.
• Enhanced decision-making.
• Increased efficiency.
• Improved compliance.
• Risk mitigation.`,
    stats: [
      { value: "35%", label: "Asset lifecycle cost savings", color: "#8E24AA" },
      { value: "5x", label: "Improved tracking accuracy", color: "#43A047" },
      { value: "80%", label: "Automation in maintenance", color: "#E91E63" },
    ],
  },
  {
    img: bg4,
    logo: SmartToyRounded,
    label: "AI ChatBot",
    title: "Enhancing Customer Engagement with AI Chatbots",
    subtitle: `Our advanced AI chatbots leverage natural language processing to deliver human-like conversational experiences. 
    They handle complex queries across multiple languages while integrating seamlessly with your CRM systems. 
    With continuous machine learning, our bots improve response accuracy by 15% monthly. 
    Features include sentiment analysis, transaction processing, and seamless human agent handoffs. 
    Businesses report 60% reduction in support tickets and 45% higher customer satisfaction scores.`,
    stats: [
      { value: "3x", label: "Customer interaction speed", color: "#8E24AA" },
      { value: "92%", label: "User satisfaction boost", color: "#4CAF50" },
      { value: "250k+", label: "Queries handled monthly", color: "#E91E63" },
    ],
  },
  {
    img: bg5,
    logo: SmartDisplayRounded,
    label: "AI Video",
    title: "Boosting Engagement Through AI-Generated Videos",
    subtitle: `Our AI video platform transforms scripts into studio-quality productions with realistic avatars and dynamic editing. 
    The system auto-generates captions, background scores, and scene transitions while maintaining brand guidelines. 
    Supports 50+ languages with emotion-aware voice synthesis and automatic lip-sync technology. 
    Clients achieve 3x more video output at 70% lower production costs compared to traditional methods. 
    Includes analytics for tracking viewer engagement down to the second.`,
    stats: [
      { value: "400%", label: "Content production speed", color: "#FF9800" },
      { value: "75%", label: "Viewer retention increase", color: "#3F51B5" },
      { value: "5x", label: "More engagement on reels", color: "#00BCD4" },
    ],
  },
  {
    img: bg6,
    logo: TrendingUpRounded,
    label: "Digital Marketing",
    title: "Driving Conversions with Strategic Digital Marketing",
    subtitle: `Our full-funnel marketing approach combines precision targeting with behavioral analytics for maximum ROI. 
    We deploy multi-channel campaigns across Google Ads, Meta, LinkedIn, and programmatic networks with unified tracking. 
    Proprietary algorithms optimize bids in real-time based on 28+ performance indicators. 
    Includes A/B testing framework that improves conversion rates by 30-50% within 3 months. 
    Clients typically see 5-8x ROAS with our managed service plans.`,
    stats: [
      { value: "500%", label: "Lead generation boost", color: "#8E24AA" },
      { value: "$600k", label: "Revenue from ads", color: "#4CAF50" },
      { value: "3.8x", label: "Better conversion rates", color: "#E91E63" },
    ],
  },
  {
    img: bg7,
    logo: TrendingUpRounded,
    label: "SEO",
    title: "Dominating Search Rankings with Technical SEO",
    subtitle: `Our enterprise SEO framework addresses technical infrastructure, content strategy, and authoritative link building. 
    Includes comprehensive site audits, semantic content optimization, and penalty recovery services. 
    We implement schema markup, Core Web Vitals optimization, and AI-powered content gap analysis. 
    Clients achieve first-page rankings for 85% of target keywords within 6-9 months. 
    Ongoing monitoring includes algorithm update protection and competitor benchmarking.`,
    stats: [
      { value: "420%", label: "Increase in Organic Traffic", color: "#FF7043" },
      { value: "$480k", label: "Annual ROI Boost", color: "#43A047" },
      { value: "5x", label: "Improved Page Rankings", color: "#29B6F6" },
    ],
  },
  {
    img: bg8,
    logo: TrendingUpRounded,
    label: "Web & Mobile Development",
    title: "Building Scalable and User-Centric Digital Products",
    subtitle: `We engineer performant applications using React, Flutter, and Node.js with microservices architecture. 
    Our development process includes UX research, prototype testing, and CI/CD pipeline integration. 
    Solutions feature real-time analytics, offline capabilities, and biometric security protocols. 
    Apps consistently score 90+ in Lighthouse audits with sub-200ms API response times. 
    Post-launch support includes performance monitoring and quarterly feature upgrades.`,
    stats: [
      { value: "99.9%", label: "Uptime on deployed apps", color: "#00BCD4" },
      { value: "75%", label: "Faster time-to-market", color: "#3F51B5" },
      { value: "4.5⭐", label: "Average user satisfaction", color: "#FF9800" },
    ],
  },
];

export default function SEOCaseStudyCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  // helper to pick circular neighbors
  const getCardAt = (offset) => {
    const idx = (activeIndex + offset + cards.length) % cards.length;
    return cards[idx];
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        py: { xs: 3, md: 5 },
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Navigation Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          mt: 6,
          gap: { xs: 2, md: 4 },
          px: 2,
        }}
      >
        {cards.map((item, idx) => (
          <Button
            key={idx}
            onClick={() => setActiveIndex(idx)}
            disableRipple
            startIcon={
              <Avatar
                src={item.logo}
                alt={item.label}
                sx={{ width: 45, height: 45 }}
              />
            }
            sx={{
              px: 2,
              py: 1,
              color: activeIndex === idx ? "#a10304" : "#032262",
              transition: "opacity 0.3s ease-in-out",
              fontSize: { xs: "0.85rem", md: "1.2rem" },
              fontWeight: "bold",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            {item.label}
          </Button>
        ))}
      </Box>
      {/* Carousel Container - Now non-scrollable and centered */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center", // Center the cards horizontally
          gap: { xs: 2, sm: 3, md: 4 },
          px: { xs: 2, md: 6 },
          mt: 4,
          overflow: "visible", // Remove scrolling
        }}
      >
        {[getCardAt(-1), getCardAt(0), getCardAt(1)].map((card, i) => (
          <Box
            key={i}
            sx={{
              scrollSnapAlign: "center",
              flex: "0 0 auto",
              width: {
                xs: i === 1 ? "90%" : "70%",
                sm: i === 1 ? "70%" : "50%",
                md: i === 1 ? "70%" : "30%",
              },
              minWidth: 0,
              height: { xs: "auto", sm: "750px", md: "680px",lg : "600px" },
              opacity: i === 1 ? 1 : 0.7,
              transform: i === 1 ? "scale(0.95)" : "scale(0.95)",
              transition: "all 0.4s ease",
              background: `
                linear-gradient(to right, rgba(0, 0, 0, 1), transparent 50%, transparent 30%, rgba(0, 0, 0, 1)),
                linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), // Mild overlay over entire image
                url(${card.img}) center center / cover no-repeat`,
              color: "#fff",
              p: { xs: 1.5, sm: 2.5, md: 4 },
              borderRadius: 8,
              boxShadow: 6,
              position: "relative",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15))", // Additional mild overlay
                borderRadius: 8,
              },
              "& > *": {
                position: "relative",
                zIndex: 1, // Ensure content stays above overlays
              },
            }}
          >
            {/* Content - Improved alignment */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" }, // Row on desktop, column on mobile
                justifyContent: "center", // Center vertically
                alignItems: "center", // Center horizontally
                width: "100%",
                height: "100%",
                position: "relative",
                overflow: "hidden", 
              }}
            >
              {/* Left content - vertically centered, left-aligned */}
              <Box
                sx={{
                  width: { xs: "100%", md: "60%" }, // 60% on desktop, full width on mobile
                  alignSelf: "center", // Center vertically
                  position: { xs: "relative", md: "absolute" },// Absolute positioning on desktop
                  left: { xs: 0, md: 0 }, // Stick to left on desktop
                  top: { xs: "auto", md: "50%" }, // Center vertically on desktop
                  transform: { xs: "none", md: "translateY(-50%)" }, // Adjust vertical center
                  p: { xs: 2, md: 4 },
                  textAlign: "left", // Left-align text
                }}
              >
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ fontSize: { xs: "1.3rem", md: "2rem" } }}
                >
                  {card?.title}
                </Typography>
                <Typography
                  variant="body2"
                  mb={2}
                  sx={{
                    fontSize: { xs: "0.85rem", md: "1rem" },
                    whiteSpace: "pre-line",
                    lineHeight: 1.8,
                  }}
                >
                  {card?.subtitle}
                </Typography>
              </Box>

              {/* Right stats - vertically centered, right-aligned */}
              <Box
                sx={{
                  width: { xs: "100%", md: "40%" }, // 40% on desktop, full width on mobile
                  alignSelf: "center", // Center vertically
                  position: { xs: "static", md: "absolute" }, // Absolute positioning on desktop
                  right: { xs: 0, md: "-20%" }, // Stick to right on desktop
                  top: { xs: "auto", md: "50%" }, // Center vertically on desktop
                  transform: { xs: "none", md: "translateY(-50%)" }, // Adjust vertical center
                  p: { xs: 2, md: 4 },
                }}
              >
                {card?.stats?.map((stat, idx2) => (
                  <Box
                    key={idx2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start", // Align entire stat item to the right
                      mt: 3,
                      width: "100%", // Ensure full width
                    }}
                  >
                    {/* Bar with fixed position */}

                    {/* Vertical bar on the left */}
                    <Box
                      sx={{
                        width: 3,
                        height: 40,
                        backgroundColor: stat?.color,
                        borderRadius: "4px",
                        mr: 2,
                        flexShrink: 2,
                      }}
                    />

                    {/* Text content - aligned to the left */}
                    <Box
                      sx={{
                        textAlign: "left",
                        flex: "0 0 auto",
                        minWidth: 0,
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          color: "white",
                          fontSize: { xs: "1.2rem", md: "2rem" },
                          lineHeight: 1,
                        }}
                      >
                        {stat?.value}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "white",
                          mt: 0.5,
                          fontSize: { xs: "0.75rem", md: "1rem" },
                        }}
                      >
                        {stat?.label}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>

      
    </Box>
  );
}

